import React from 'react';
import './App.css';
import MarkdownVisualizer from './components/MarkdownVisualizer';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <div className="App">
      <MarkdownVisualizer />
      <Analytics />
    </div>
  );
}

export default App;